<template>
  <div style="margin-top: 3rem;">

 <!-- https://unsplash.com/photos/F77D9r-qIqU -->
 <!-- https://unsplash.com/photos/lG8ANgv7p2k -->

  <div>
    <b-img src="/public/downloads/directories/images/ArcDeTriomphe.jpg" fluid alt="Arc de Triomphe"></b-img>
  </div>
  <br/>
  <br/>
  <h1>Ehrenphilister der PV BUND 1895 zu Bruchsal</h1>

  <br/>
  <br/>
  <p>In ihrer mehr als 120-jähigen Verbindungsgeschichte wurde folgenden Mitgliedern aufgrund ihrer besonderen Verdienste die
  höchste Auszeichnung, die Ehrenphilisterwürde, verliehen.</p>
  <br/>
  <br/>

    <b-table
        striped
        hover
        dark
        primary-key="id"
        :items="items" :fields="fields"
     >
           <span slot="name" slot-scope="data" v-html="data.value"></span>
     </b-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
          fields: [
            {
              key: 'id',
              label: '#'
            },
            {
              key: 'name'
            }
          ],
        items: [ // &#8224;
          { id:  1, name: 'Otto Ammann, Dipl. Ing. (* 1887) (&#8224; 1917)'} ,
          { id:  2, name: 'Hermann Kreuzer, Hauptmann (* 1879) (&#8224; 1914)'} ,
          { id:  3, name: 'Heinrich Metzger, Fabrikant (* 1887) (&#8224; 1914)'} ,
          { id:  4, name: 'Dr. phil. Heinrich Maas (* 09.09.1889) (&#8224; 07.06.1969)'} ,
          { id:  5, name: 'Prof. Wilhelm Bender (* 04.02.1888) (&#8224; 25.07.1969)'} ,
          { id:  6, name: 'Dr. phil. Hans Ebbecke (* 08.03.1893) (&#8224; 15.05.1973)'} ,
          { id:  7, name: 'Karl Geitz, Kunstmaler (* 16.10.1889) (&#8224; 23.11.1980)'} ,
          { id:  8, name: 'Prof. Dr. med. Oswald Geissler (* 13.07.1893) (&#8224; 17.10.1980)'} ,
          { id:  9, name: 'Prof. Walter Stritt (* 03.08.1892) (&#8224; 04.11.1975)'} ,
          { id: 10, name: 'Edmund Ulmer, Bauunternehmer (* 20.07.1894) (&#8224; 31.03.1973)'} ,
          { id: 11, name: 'Dr. Oskar Schönig, Zahnarzt (* 26.07.1896) (&#8224; 04.08.1984)'} ,
          { id: 12, name: 'Alfred Kammerer, Dipl. Volkswirt (* 18.02.1902) (&#8224; 1992)'} ,
          { id: 13, name: 'Werner Nowacki, Tierarzt (* 24.10.1913) (&#8224; 21.09.2011)'} ,
          { id: 14, name: 'Ewald Maurer, Apotheker (* 01.04.1916) (&#8224; 21.01.1993)'} ,
          { id: 15, name: 'Siegfried Seifert, Prokurist (* 12.10.1913) (&#8224; 21.12.2000)'} ,
          { id: 16, name: 'Ernst Gaus, Notariats-Direktor (* 04.07.1913) (&#8224; 24.07.2000)'} ,
          { id: 17, name: 'Dr. med. Hans-Jochen Lupp (* 06.12.1933)' },
          { id: 18, name: 'Bernd Braunbarth, Diplom-Kaufmann (* 20.10.1964)' },
          { id: 19, name: 'Kurt Lupp, Kunstmaler (* 29.03.1935)' },
          { id: 20, name: 'Gottfried Grauer, Rechtsanwalt (* 08.05.1946)' },
        ]
      }
    }
  }
</script>
